import React from "react";
import ICON_OPTIONS from "../../utils/iconOptions";

const IconSelect = ({ value, onChange, className, t }) => (
  <select name="image" id="icon" className={className} value={value} onChange={onChange}>
    <option value=""> {t("select")}</option>
    {ICON_OPTIONS.map((option) => (
      <option key={option.value} value={option.value}>
        {option.translate ? t(option.label) : option.label}
      </option>
    ))}
  </select>
);

export default IconSelect;
